// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"2f4773cf","199":"1ce2a342","487":"eda6f1ce","489":"8b56bc16","533":"0111d41c","562":"2a8fe2a8","653":"aac26ee9","745":"2626139a","871":"2ee99b8f","944":"f2ba3584","958":"4d8239fe"}[chunkId] + ".chunk.js";
};